import { render, staticRenderFns } from "./NodeManagement.vue?vue&type=template&id=5d047ce8&"
import script from "./NodeManagement.vue?vue&type=script&lang=js&"
export * from "./NodeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports